import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';

import {
  GetFunctionsQuery,
  GetFunctionsResponse,
} from '@hud/portal-dtos/webapp-function.dto';
import { PORTAL_BASE } from '../consts';

export const FLOW_FUNCTIONS_ID = 'flow-functions';

export default function useFlowFunctions(
  flowId?: number,
  serviceId?: number,
  params?: GetFunctionsQuery,
) {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [FLOW_FUNCTIONS_ID, flowId, params],
    queryFn: async () => {
      const response = await client.get<GetFunctionsResponse>(
        `${PORTAL_BASE}/endpoints/${flowId}/${serviceId}/functions`,
        { params },
      );
      return GetFunctionsResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
